import { StatusResponse } from "../domain/models/StatusResponse";
import { SessionRepository } from "../domain/repositories/SessionRepository";
import { axiosApp } from "./remote/AxiosFactory";
import { handleRemoteResponse } from "./remote/hanldeRemoteResponse";
import { IpData } from '../domain/models/IpData';
import { AppSession } from "../domain/models/AppSession";
import { handleAxiosResult } from './remote/handleAxiosResult';
import { sessionLocalRepo } from '../di/repo_module';
import { AppError } from '../common/erros/AppError';

export class SessionDataRepository implements SessionRepository {

    async login(pos: string, password: string, user: string | undefined): Promise<AppSession> {
        const encodePass = encodeURIComponent(password)
        const userParam = (user !== undefined && user.trim().length > 0) ? `&user=${user.trim()}` : '';
        const endpoint = `/pos/login?pointOfSale=${pos}${userParam}&password=${encodePass}`;
        const result = await handleAxiosResult(axiosApp().get(endpoint));
        return handleRemoteResponse(result, (r: any) => {
            return new AppSession({
                ...r,
                puntoVenta: pos
            });
        })
    }

    async posHasUsers(pos: string): Promise<{ pos_has_users: boolean; pos_has_2fa: boolean }>  {
        const endpoint = `/pos/has/users?pointOfSale=${pos}`;
        const result = await handleAxiosResult(axiosApp().get(endpoint));
        return handleRemoteResponse(result, (r: any) => {
            const posHasUsers = r.pos_has_users ?? false;
            const posHas2FA = r.pos_has_2fa ?? false;
            return { pos_has_users: posHasUsers, pos_has_2fa: posHas2FA };
        });
    }

    //https://stackoverflow.com/questions/391979/how-to-get-clients-ip-address-using-javascript
    async getIp(): Promise<IpData> {
        /*const endpoint = 'https://api.ipify.org/?format=json'
        const result = await handleAxiosResult(axiosApp(false).get(endpoint, { baseURL: "" }));
        if (result.status === 200) {
            let r = result.data;
            sessionLocalRepo().setIp(r.ip);
            return new IpData({
                ...r,
                ip: r.ip
            });
        } else {
            throw new AppError("");
        }/**/
        return new IpData({
            ip: "_._._._"
        });
    }

    async updatePassword(oldPassword: string, newPassword: string): Promise<StatusResponse> {
        const encodeOldPass = encodeURIComponent(oldPassword)
        const encodeNewPass = encodeURIComponent(newPassword)

        const endpoint = `/pos/update/password?oldPassword=${encodeOldPass}&newPassword=${encodeNewPass}`;
        const result = await handleAxiosResult(axiosApp().get(endpoint));

        return handleRemoteResponse(result, (r: any) => {
            return new StatusResponse({
                status: true,
            });
        });

    }

    async updateSessionTime(timeInMillis: number): Promise<StatusResponse> {
        const result = await handleAxiosResult(axiosApp().get(`/pos/update/session/timeout?timeout=${timeInMillis}`));
        return handleRemoteResponse(result, (r: any) => {
            return new StatusResponse({
                status: true,
            });
        })
    }

}